import { NationalityForecastReportRequestModel } from '../api/models/NationalityForecastReportRequestModel';
import { NationalityForecastReportFormModel } from '../models';

export const dataFormToRequest = (
  data: NationalityForecastReportFormModel
): NationalityForecastReportRequestModel => {
  return {
    from: data.from,
    to: data.to,
    currency_id: data.currency ? Number(data.currency.id) : null,
    fixed_at: data?.fixed_at ? Number(data?.fixed_at) : null,
    nationality_id: data?.nationality ? +data?.nationality.id : null,
    room_type_ids: data?.roomTypeIds,
    card_id: data?.company?.id,

    gross_revenue: data?.gross_revenue,
    with_revenue: data?.with_revenue,
    currency_application: data?.currency_application,
    file_type: data?.file_type,
  };
};
